






















import { Component, Vue } from 'vue-property-decorator'
import VueCookies from 'vue-cookies'
import { namespace } from 'vuex-class'

import LayoutManager from '@/layouts/LayoutManager.vue'
import { getterTypes as errorGetterTypes } from '@/store/module/errors/getters'
import { mutationTypes as errorMutationTypes } from '@/store/module/errors/mutations'

const errors = namespace('errors');

@Component({
  components: {
    LayoutManager
  }
})
export default class App extends Vue {
  @errors.State(state => state.errors)
  readonly errors!: string[];

  @errors.Getter(errorGetterTypes.showError)
  readonly showError!: boolean;

  @errors.Mutation(errorMutationTypes.clear)
  clearErrors!: () => void;

  get showSnackbar() {
    return this.showError;
  }

  set showSnackbar(value: boolean) {
    if (!value) {
      this.clearErrors();
    }
  }
  
  mounted() {
    // @ts-ignore
    this.$vuetify.theme.dark = VueCookies.get('theme') === 'dark'
  }
}
